import { useContext } from "react";

import { ActualInventoryContext } from "../context/ActualInventoryContext";

export const useActualInventoryContext = () => {
  const context = useContext(ActualInventoryContext);

  return context;
};
